export default __webpack_public_path__ + "11c6913284898962fcad612437561119.svg";